import { GridColDef } from '@mui/x-data-grid';

import ApplicationNumberCell from './components/ApplicationNumberCell';
import BooleanStatusCell from './components/BooleanStatusCell';
import { formatQcStatusLabel } from './utils';

/* eslint-disable no-unused-vars */
const getSnapshotComparisonColumns = (
  onEdit: (applicationNumber: string) => void
): GridColDef[] => [
  {
    field: 'application_number',
    headerName: 'Application Number',
    flex: 1,
    minWidth: 260,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ value }) => (
      <ApplicationNumberCell applicationNumber={String(value)} onEdit={onEdit} />
    )
  },
  {
    field: 'qc_status',
    headerName: 'QC Status',
    flex: 1,
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: ({ value }) => formatQcStatusLabel(Boolean(value))
  },
  {
    field: 'change_detection_status',
    headerName: 'Changes Report (Available)',
    flex: 1,
    minWidth: 180,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => <BooleanStatusCell value={Boolean(value)} />
  },
  {
    field: 'escalated_status',
    headerName: 'Escalated',
    flex: 1,
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => <BooleanStatusCell value={Boolean(value)} />
  },
  {
    field: 'all_verdict_false',
    headerName: 'All Verdict False',
    flex: 1,
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => <BooleanStatusCell value={Boolean(value)} />
  }
];
/* eslint-enable no-unused-vars */

export default getSnapshotComparisonColumns;
